import React from "react";
import Classes from "./style.module.css";
import UserImg from "../../../../assets/images/lig/ProfileImg.png";

const LigRateList = ({ data }) => {
  function formatData(data) {
    const dataStr = data.toString();
    const start = dataStr.substring(0, 3);
    const end = dataStr.substring(dataStr.length - 2);
    const formattedData = `${end}**${start}`;
    return formattedData;
  }
  return (
    <div className={Classes.ligRatingListContainer}>
      <div className={Classes.tableContainer}>
        <div className={Classes.tableHeading}>
          <p>رتبه</p>
          <p>تصویر</p>
          <p>نام </p>
          <p>امتیاز</p>
        </div>
        <div className={Classes.tableBody}>
          {data.length > 0
            ? data.map((item, index) => {
                return (
                  <div className={Classes.tableElement} key={index}>
                    <div>{index + 4}</div>
                    <div>
                      <img src={UserImg} alt="user" />
                    </div>
                    <div>{`${item.name} (${formatData(item.codeMeli)})`}</div>
                    <div>{item.score}</div>
                  </div>
                );
              })
            : null}
        </div>
      </div>
    </div>
  );
};

export default LigRateList;
